import React, { useEffect, useState, useMemo, useRef } from "react";
import { useForm } from 'react-hook-form';
import MaterialTable from 'material-table';
import Select from 'react-select'

// reactstrap components
import { Button, Card, CardBody, FormGroup, Form, Input, Row, Col, Container, Modal, ModalBody, ModalFooter, UncontrolledTooltip } from "reactstrap";

// leaflet
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet'
import L from 'leaflet';

// style
import "assets/css/map.css";
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

// services
import { InputCEP } from "../../../services/mask.js";
import { showMessage, showQuestion } from "../../../services/message.js";
import { api_GET, api_POST } from "../../../services/api_service.js";
import { EnviaProtocoloGeradorLocalArmazenagem, EnviaRequerimentoGeradorLocalArmazenagem } from "../../../services/protocolo_gerador_service.js";
import { GetCEPViaCEP } from "../../../services/viaCep";

//Context
import { useAuth } from "../../../context/auth";

const TIPO_ABRIGO_EXTERNO = "Abrigo externo";

export default function LocaisArmazenagem({ item, tipoCadastro, permiteManutencao, handleProximoStep, handleStepAnterior }) {
    const { session, setLoading } = useAuth();

    const { register, handleSubmit, errors, setError, setValue, clearErrors, reset, getValues } = useForm({ mode: "onBlur" });

    const [permiteEditar, set_permiteEditar] = React.useState(true);

    const [registro, set_registro] = React.useState(null);

    const [locais_Armazenagem, set_locais_Armazenagem] = React.useState([]);

    const [modalOpen, set_modalOpen] = React.useState(false);
    const [localizacaoConfirmada, set_localizacaoConfirmada] = useState(false);

    useEffect(() => {
        if (tipoCadastro == "Protocolo")
            loadItemProtocolo();
        else if (tipoCadastro == "Requerimento")
            loadItemRequerimento();
    }, []);
    const loadItemProtocolo = () => {
        set_registro(item);
        if (item != null && item.protocoloGerador[0].protocoloGeradorLocaisArmazenagem != null) {
            set_locais_Armazenagem(item.protocoloGerador[0].protocoloGeradorLocaisArmazenagem);
        }
    }
    const loadItemRequerimento = () => {
        set_registro(item);
        if (item != null && item.requerimentoGeradorLocalArmazenagem != null) {
            set_locais_Armazenagem(item.requerimentoGeradorLocalArmazenagem);
        }

        if (tipoCadastro == "Requerimento") {
            let _action = actions;
            _action.push({
                icon: 'delete',
                tooltip: 'Remover Local',
                onClick: (event, rowData) => handleRemove(rowData)
            });

            set_actions(_action);
        }
    }

    // Material-Table > Actions
    const [actions, set_actions] = useState([
        {
            icon: 'edit',
            tooltip: 'Editar Registro',
            onClick: (event, rowData) => handleEdit(rowData)
        }
    ]);

    const [tipoAbrigo, set_tipoAbrigo] = useState(TIPO_ABRIGO_EXTERNO);

    const optionsTipoAbrigo = useMemo(() => {
        const options = [{ label: "Abrigo Externo", value: TIPO_ABRIGO_EXTERNO }];

        if (tipoAbrigo && tipoAbrigo !== TIPO_ABRIGO_EXTERNO)
            options.push({ label: tipoAbrigo, value: tipoAbrigo });

        return options;
    }, [tipoAbrigo]);

    const handleChangeTipoAbrigo = (value) => {
        set_tipoAbrigo(value);
        setValue("tipoAbrigo", value, true);
        clearErrors("tipoAbrigo");
    }

    useEffect(() => {
        setValue("tipoAbrigo", TIPO_ABRIGO_EXTERNO, true);
    }, []);

    // CEP    
    const [cep, set_cep] = React.useState("");
    const [editarEndereco, set_editarEndereco] = useState(true);
    const handleCEP = (event) => {
        set_cep(event.target.value);

        if (event.target.value.replaceAll("_", "").length != 9)
            return;

        clearErrors("cep");

        GetCEPViaCEP(event.target.value).then(result => {
            if (result.status !== 200 || (result.data.hasOwnProperty('erro') && result.data.erro == true)) {
                showMessage("Aviso", "Cep não localizado", 'warning', null);
                setValue("logradouro", "");
                setValue("bairro", "");
                setValue("cidade", "");
                setValue("uf", "");
            }
            else {
                setValue("logradouro", result.data.logradouro);
                setValue("bairro", result.data.bairro);
                setValue("cidade", result.data.localidade);
                setValue("uf", result.data.uf);

                if (result.data.logradouro == null || result.data.logradouro.length == 0)
                    set_editarEndereco(false);
                else {
                    set_editarEndereco(true);

                    let chave = result.data.logradouro.replaceAll(" ", "+") + "," + result.data.bairro.replaceAll(" ", "+") + result.data.localidade.replaceAll(" ", "+");
                    UpdatePositionEndereco(chave);
                }
            }
        });
    }
    const handleNumeroChange = (value) => {
        let data = getValues();
        let chave = data.logradouro.replaceAll(" ", "+") + "," + value + "," + data.bairro.replaceAll(" ", "+") + data.cidade.replaceAll(" ", "+");
        UpdatePositionEndereco(chave);
    }

    const UpdatePositionEndereco = (chave) => {
        setLoading(true);
        api_POST(`GeoCoding/GetPositionEndereco`, chave)
        .then((result) => {
        setLoading(false);
        if (result.status !== 200) {
            showMessage("Não foi possível localizar as coordenadas do endereço.", "Informe no mapa a localização!", "error", null);
        } else {
            try {
            setCenterMap([
                result?.data?.latitude?.replace(",", "."),
                result?.data?.longitude?.replace(",", "."),
            ]);
            setpositionMarker([
                result?.data?.latitude?.replace(",", "."),
                result?.data?.longitude?.replace(",", "."),
            ]);
            } catch {
            showMessage("Não foi possível localizar as coordenadas do endereço.", "Informe no mapa a localização!", "error", null);
            }
        }
        })
        .catch((err) => showMessage("Aviso", err.message, "error", null))
        .finally(() => setLoading(false));
    }

    // Mapa    
    const [centerMap, setCenterMap] = useState([0, 0]);
    const [positionMarker, setpositionMarker] = useState([0, 0]);
    const iconMarker = new L.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png',
        iconRetinaUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png',
    });
    const markerRef = useRef(null)
    const handleMarkerPosition = useMemo(
        () => ({
            dragend() {
                const marker = markerRef.current
                if (marker != null) {
                    let position = marker.getLatLng();
                    setpositionMarker([position.lat, position.lng]);
                }
            },
        }),
        [],
    )
    const ChangeMap = ({ center, zoom }) => {
        const mapInstance = useMap();
        mapInstance.setView(center, zoom);
        return null;
    }
    const handleModalClose = () => {
        set_modalOpen(false);
        set_localizacaoConfirmada(true);
    }

    const [rowEdit, set_rowEdit] = React.useState(null);

    // Regra SP Regula: permitido informar apenas um local de armazenagem por cadastro.
    // Registros legados com mais de um local continuam sendo exibidos e editáveis.
    const limiteLocaisAtingido = locais_Armazenagem.length >= 1 && rowEdit == null;

    const handleEdit = (rowData) => {
        set_localizacaoConfirmada(false);
        set_rowEdit(rowData);
        set_cep(rowData.cep);
        setValue("cep", rowData.cep);
        setValue("logradouro", rowData.logradouro);
        setValue("numEndereco", rowData.numEndereco);
        setValue("complemento", rowData.complemento);
        setValue("bairro", rowData.bairro);
        setValue("cidade", rowData.cidade);
        setValue("uf", rowData.uf);
        // Registros legados podem ter outro tipo de abrigo; o valor é preservado apenas para leitura.
        let _tipoAbrigo = rowData.tipoAbrigo || TIPO_ABRIGO_EXTERNO;
        set_tipoAbrigo(_tipoAbrigo);
        setValue("tipoAbrigo", _tipoAbrigo, true);

        if (rowData.geoLocalizacao && rowData.geoLocalizacao.split(";").length > 1) {
            setCenterMap([rowData.geoLocalizacao.split(";")[0], rowData.geoLocalizacao.split(";")[1]]);
            setpositionMarker([rowData.geoLocalizacao.split(";")[0], rowData.geoLocalizacao.split(";")[1]]);
        }
    }

    const handleRemove = (rowData) => {
        if (!permiteManutencao && tipoCadastro == "Protocolo") {
            showMessage("Aviso", "Não permitida a manutenção do cadastro.", 'error', null);
            return;
        }

        showQuestion('Atenção', 'Deseja remover este local?', 'question', function (result) {
            if (result) {
                setLoading(true);
                api_POST('requerimentoGerador/PostRemoverGeradorLocalArmazenagemRequerimento/' + rowData.requerimentoGeradorLocalArmazenagem_Id)
                    .then(result => { 
                        const locaisAtualizados = item.requerimentoGeradorLocalArmazenagem.filter(local => local.requerimentoGeradorLocalArmazenagem_Id !== rowData.requerimentoGeradorLocalArmazenagem_Id);
                        item.requerimentoGeradorLocalArmazenagem = locaisAtualizados;
                        showMessage("Aviso", "Local removido com sucesso!", 'success', function () { handleReturnRemove(rowData.requerimento_Id) }) 
                    })
                    .catch(err => showMessage("Aviso", err.message, 'error', null))
                    .finally(() => setLoading(false));
            }
        })
    }
    const handleReturnRemove = (reloadId) => {
        setLoading(true);

        api_GET('requerimentoGerador/GetLocaisArmazenagemRequerimentoGerador/' + reloadId)
            .then(result => set_locais_Armazenagem(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const onSubmit = (data) => {
        if (limiteLocaisAtingido) {
            showMessage("Aviso", "É permitido informar apenas um local de armazenagem.", 'error', null);
            return;
        }

        if (!localizacaoConfirmada) {
            showMessage("Aviso", "Antes de salvar o registro efetue a confirmação da localização no mapa!", 'error', null);
            return;
        }

        if (rowEdit == null && locais_Armazenagem.filter(f => f.cEP == data.cep && f.numEndereco == data.numEndereco).length > 0) {
            showMessage("Aviso", "Já existe um local de armazenagem neste endereço!", 'error', null);
            return;
        }

        setLoading(true);
        if (permiteManutencao && tipoCadastro == "Protocolo") {
            let json = carregaJsonProtocolo(data);
            EnviaProtocoloGeradorLocalArmazenagem(json, confirmaAddLocaisArmazenagem)
        }
        else if (tipoCadastro == "Requerimento") {
            let json = carregaJsonRequerimento(data);
            EnviaRequerimentoGeradorLocalArmazenagem(json, confirmaAddLocaisArmazenagem)
        }
    }
    const carregaJsonProtocolo = (data) => {
        let json_submit = {
            protocoloGeradorLocalArmazenagem_Id: rowEdit == null ? 0 : rowEdit.protocoloGeradorLocalArmazenagem_Id,
            protocoloGerador_Id: item.protocoloGerador[0].protocoloGerador_Id,
            cEP: data.cep.replace(/[^0-9]/g, ''),
            logradouro: data.logradouro,
            numEndereco: data.numEndereco,
            complemento: data.complemento,
            bairro: data.bairro,
            cidade: data.cidade,
            uf: data.uf,
            tipoAbrigo: tipoAbrigo,
            geoLocalizacao: positionMarker[0] + ";" + positionMarker[1],
            status: "Ativo",
            usuarioUltimaAlteracao_Id: session != null && session.tipoAcesso == "AreaRestrita" ? session.usuario_Id : null
        }
        return json_submit;
    }
    const carregaJsonRequerimento = (data) => {
        let json_submit = {
            requerimentoGeradorLocalArmazenagem_Id: rowEdit == null ? 0 : rowEdit.requerimentoGeradorLocalArmazenagem_Id,
            requerimento_Id: item.requerimento_Id,
            cEP: data.cep,
            logradouro: data.logradouro,
            numEndereco: data.numEndereco,
            complemento: data.complemento,
            bairro: data.bairro,
            cidade: data.cidade,
            uf: data.uf,
            tipoAbrigo: tipoAbrigo,
            geoLocalizacao: positionMarker[0] + ";" + positionMarker[1],
            status: "Ativo",
            usuarioUltimaAlteracao_Id: session != null && session.tipoAcesso == "AreaRestrita" ? session.usuario_Id : null
        }
        return json_submit;
    }
    const confirmaAddLocaisArmazenagem = (result) => {
        setLoading(false);
        set_localizacaoConfirmada(false);
        set_tipoAbrigo(TIPO_ABRIGO_EXTERNO);
        setValue("tipoAbrigo", TIPO_ABRIGO_EXTERNO, true);

        let local = result.data;

        let new_list = [];

        let _registro = registro;
        if (tipoCadastro == "Protocolo") {
            locais_Armazenagem.map(m => {
                if (m.protocoloGeradorLocalArmazenagem_Id != local.protocoloGeradorLocalArmazenagem_Id)
                    new_list.push(m);
            });

            _registro.protocoloGerador[0].protocoloGeradorLocaisArmazenagem = new_list;
        }
        else if (tipoCadastro == "Requerimento") {
            locais_Armazenagem.map(m => {
                if (m.requerimentoGeradorLocalArmazenagem_Id != local.requerimentoGeradorLocalArmazenagem_Id)
                    new_list.push(m);
            });

            _registro.requerimentoGeradorLocalArmazenagem = new_list;
        }

        new_list.push(local);
        set_locais_Armazenagem(new_list);
        set_registro(_registro);

        set_cep("");
        setValue("cep", "");
        setValue("logradouro", "");
        setValue("numEndereco", "");
        setValue("complemento", "");
        setValue("bairro", "");
        setValue("cidade", "");
        setValue("uf", "");

        set_rowEdit(null);

        showMessage("Aviso", "Operação executada com sucesso", 'success', null);
    }

    const handleAvancar = () => {
        if ((session == null || (session && session.tipoAcesso == "Protocolo")) && locais_Armazenagem.length == 0) {
            showMessage("Aviso", "Você não pode avançar sem informar os locais de armazenagem", 'error', null);
            return;
        }
        handleProximoStep(registro);
    }

    return (
        <>
            <div>

                <Card className={`card-stats`}>
                    <CardBody>
                        <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                            <h2 className="titulo-solicitacao">Locais de Armazenagem</h2>
                            <div className="formPrincipal">
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    <Row>
                                        <Col md="3" lg="3">
                                            <FormGroup>
                                                <b><label>CEP</label></b>
                                                <InputCEP name="cep" onChange={handleCEP} value={cep} inputRef={register({ required: session && session != null && session.tipoAcesso == "AreaRestrita" ? false : true })} />
                                                {errors.cep && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="5" lg="5">
                                            <FormGroup>
                                                <b><label>Logradouro</label></b>
                                                <Input type="text" name="logradouro" readOnly={editarEndereco} maxLength="100" innerRef={register({ required: session && session != null && session.tipoAcesso == "AreaRestrita" ? false : true })} />
                                                {errors.logradouro && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="4" lg="4">
                                            <FormGroup>
                                                <b><label>Bairro</label></b>
                                                <Input type="text" name="bairro" readOnly={editarEndereco} maxLength="50" innerRef={register({ required: session && session != null && session.tipoAcesso == "AreaRestrita" ? false : true })} />
                                                {errors.bairro && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="2" lg="2">
                                            <FormGroup>
                                                <b><label>Número</label></b>
                                                <Input type="number" name="numEndereco" maxLength="10" innerRef={register({ required: session && session != null && session.tipoAcesso == "AreaRestrita" ? false : true })} onBlur={(e) => handleNumeroChange(e.target.value)} />
                                                {errors.numEndereco && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="3" lg="3">
                                            <FormGroup>
                                                <b><label>Complemento</label></b>
                                                <Input type="text" name="complemento" maxLength="50" innerRef={register({ required: false })} />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4" lg="4">
                                            <FormGroup>
                                                <b><label>Cidade</label></b>
                                                <Input type="text" name="cidade" readonly="readonly" maxLength="50" innerRef={register({ required: session && session != null && session.tipoAcesso == "AreaRestrita" ? false : true })} />
                                                {errors.cidade && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="1" lg="1">
                                            <FormGroup>
                                                <b><label>UF</label></b>
                                                <Input type="text" name="uf" readonly="readonly" innerRef={register({ required: session && session != null && session.tipoAcesso == "AreaRestrita" ? false : true })} />
                                                {errors.uf && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="1" lg="1">
                                            <Button color="info" className="btn-mobile" type="button" onClick={() => set_modalOpen(true)}><i className="fas fa-map-marked-alt"></i></Button>
                                        </Col>
                                        <Col md="4" lg="4">
                                            <FormGroup>
                                                <b>
                                                    <label>
                                                        Tipo de Abrigo{" "}
                                                        <a href="#" id="questionTipoAbrigo" onClick={(e) => e.preventDefault()}>
                                                            <i className="fas fa-question-circle"></i>
                                                        </a>
                                                        <UncontrolledTooltip
                                                            target="questionTipoAbrigo"
                                                            placement="top"
                                                            autohide={false}
                                                        >
                                                            <b>Abrigo Externo (ou Central)</b>: O <b>abrigo externo</b> fica fora do estabelecimento, protegendo os resíduos do tempo e facilitando o acesso direto dos caminhões de coleta.
                                                            <br />
                                                            <i>
                                                                *Regulado pela{" "}
                                                                <a
                                                                    href="https://estudoemfocosaude.com.br/armazenamento-externo-anvisa/"
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="text-white text-underline"
                                                                >
                                                                    <u>Anvisa na RDC 222/2018</u>
                                                                </a>
                                                                , serve para organizar o fluxo de descarte de clínicas e hospitais.
                                                            </i>
                                                        </UncontrolledTooltip>
                                                    </label>
                                                </b>
                                                <Select
                                                    options={optionsTipoAbrigo}
                                                    getOptionLabel={option => option.label}
                                                    getOptionValue={option => option.value}
                                                    name="tipoAbrigo"
                                                    onChange={(e) => { handleChangeTipoAbrigo(e.value) }}
                                                    value={tipoAbrigo && optionsTipoAbrigo.find(obj => obj.value === tipoAbrigo)}
                                                    placeholder="Selecione"
                                                    ref={e => register(
                                                        { name: "tipoAbrigo" },
                                                        { required: session && session != null && session.tipoAcesso == "AreaRestrita" ? false : true })
                                                    }
                                                    isDisabled={true}
                                                />
                                                {errors.tipoAbrigo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        {permiteEditar && !limiteLocaisAtingido &&
                                            <Col lg="12" className="text-center">
                                                <FormGroup>
                                                    <Button color="success" className="btn-mobile" type="submit">  <i className="fas fa-save"></i> Salvar Local</Button>
                                                </FormGroup>
                                            </Col>
                                        }
                                        {limiteLocaisAtingido &&
                                            <Col lg="12" className="text-center">
                                                <FormGroup>
                                                    <span className="form-control-label text-danger">É permitido informar apenas um local de armazenagem. Para alterar o endereço, utilize a opção de edição no local já cadastrado.</span>
                                                </FormGroup>
                                            </Col>
                                        }
                                    </Row>
                                </Form>
                            </div>
                            <Row>
                                <Col md="12">
                                    <MaterialTable style={{ minHeight: "auto" }}
                                        title=""
                                        columns={[
                                            { title: 'CEP', field: 'cep' },
                                            { title: 'Logradouro', field: 'logradouro' },
                                            { title: 'Número', field: 'numEndereco' },
                                            { title: 'Complemento', field: 'complemento' },
                                            { title: 'Bairro', field: 'bairro' },
                                            { title: 'Cidade', field: 'cidade' },
                                            { title: 'UF', field: 'uf' }
                                        ]}
                                        data={locais_Armazenagem}
                                        isLoading={false}
                                        actions={actions}
                                        localization={table_translate}
                                        options={table_style}
                                    />
                                </Col>
                                <Col lg="6" className="text-left">
                                    <Button color="secundary" onClick={() => handleStepAnterior(registro)} className="btn-mobile" type="submit"><i className="fas fa-chevron-left"></i> Voltar</Button>
                                </Col>
                                <Col lg="6" className="text-right">
                                    <Button color="success" onClick={handleAvancar} className="btn-mobile" type="button">Próxima Etapa  <i className="fas fa-chevron-right"></i></Button>
                                </Col>
                            </Row>
                        </Container>
                    </CardBody>
                </Card>
            </div>
            <Modal centered isOpen={modalOpen} toggle={handleModalClose} zIndex="9999999">
                <ModalBody className="md-bd">
                    <h6>Confirme o Local no Mapa</h6>
                    <Row className="mt-2">
                        <Col lg="12">
                            <div id="map">
                                <MapContainer style={{ zIndex: "0" }} >
                                    <ChangeMap center={centerMap} zoom={20}></ChangeMap>
                                    <TileLayer
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                        opacity={0.5}
                                    />
                                    <Marker position={positionMarker} draggable={true} icon={iconMarker} ref={markerRef} eventHandlers={handleMarkerPosition}></Marker>
                                </MapContainer>
                            </div>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter className="md-ft">
                    <Button color="secondary" outline onClick={handleModalClose}>Confirmar</Button>
                </ModalFooter>
            </Modal>
        </>
    );
}